import { render, staticRenderFns } from "./SectionOptionsModal.vue?vue&type=template&id=f3127782"
import script from "./SectionOptionsModal.vue?vue&type=script&lang=js"
export * from "./SectionOptionsModal.vue?vue&type=script&lang=js"
import style0 from "./SectionOptionsModal.vue?vue&type=style&index=0&id=f3127782&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports